/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronDownLeft = createReactComponent(
  "chevron-down-left",
  "IconChevronDownLeft",
  [["path", { d: "M8 8v8h8", key: "svg-0" }]]
);

export { IconChevronDownLeft as default };
//# sourceMappingURL=IconChevronDownLeft.js.map
